"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames2 = _interopRequireDefault(require("classnames"));

var _excluded = ["alertType", "autoClose", "autoCloseTimeout", "autoFocusAlertButton", "children", "className", "dismissable", "onBeforeClose", "position", "show", "sidenav", "triggerRef"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CSS_PREFIX = 'vds-alert';
var CSS_STATE = 'vds-state';
var Alert = (0, _react.forwardRef)(function (_ref, ref) {
  var _classnames;

  var alertType = _ref.alertType,
      autoClose = _ref.autoClose,
      autoCloseTimeout = _ref.autoCloseTimeout,
      autoFocusAlertButton = _ref.autoFocusAlertButton,
      children = _ref.children,
      className = _ref.className,
      dismissable = _ref.dismissable,
      onBeforeClose = _ref.onBeforeClose,
      position = _ref.position,
      show = _ref.show,
      sidenav = _ref.sidenav,
      triggerRef = _ref.triggerRef,
      remainingProps = _objectWithoutProperties(_ref, _excluded);

  ref = ref || (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (autoClose && show && Number(autoCloseTimeout)) {
      setTimeout(function () {
        return onBeforeClose();
      }, autoCloseTimeout);
    }
  }, [autoClose, autoCloseTimeout, onBeforeClose, show]);
  (0, _react.useEffect)(function () {
    if (dismissable && autoFocusAlertButton && show && ref && ref.current) {
      ref.current.querySelector('button:not([disabled]):not(.vds-state--disabled)').focus();
    }

    if (dismissable && autoFocusAlertButton && !show && triggerRef && triggerRef.current) {
      triggerRef.current.focus();
    }
  }, [autoFocusAlertButton, dismissable, ref, show, triggerRef]);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames2.default)(CSS_PREFIX, (_classnames = {}, _defineProperty(_classnames, "".concat(CSS_PREFIX, "--").concat(alertType), Boolean(alertType)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--").concat(position), Boolean(position)), _defineProperty(_classnames, "".concat(CSS_STATE, "--show"), Boolean(show)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--sidenav--").concat(sidenav), Boolean(sidenav)), _classnames), className),
    ref: ref
  }, remainingProps), children);
});
Alert.propTypes = {
  /**
   * Alert Type
   */
  alertType: (0, _propTypes.oneOf)(['error', 'information', 'success', 'warning']),

  /**
   * Auto-close
   */
  autoClose: _propTypes.bool,

  /**
   * Auto-close Timeout
   */
  autoCloseTimeout: _propTypes.number,

  /**
   * Auto-focus on alert button
   */
  autoFocusAlertButton: _propTypes.bool,

  /**
   * @ignore
   */
  children: _propTypes.node.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.string,

  /**
   * Dismissable Alert
   */
  dismissable: _propTypes.bool,

  /**
   * On before close
   */
  onBeforeClose: _propTypes.func,

  /**
   * Position
   */
  position: (0, _propTypes.oneOf)(['absolute', 'relative']),

  /**
   * @ignore
   */
  role: _propTypes.string,

  /**
   * Show
   */
  show: _propTypes.bool,

  /**
   *  Sidenav state
   */
  sidenav: (0, _propTypes.oneOf)(['close', 'open']),

  /**
   *  Ref of button that opened the Alert for focus back when Alert closes
   */
  triggerRef: (0, _propTypes.shape)({})
};
Alert.defaultProps = {
  autoCloseTimeout: 3000
};
Alert.displayName = 'Alert';
var _default = Alert;
exports.default = _default;